<template>
    <slot name="start" />
    <v-text-field
        v-if="isEditing"
        v-model="rowData"
        :placeholder="`${$t(`${title}`)}`"
        :loading="isLoading"
        :disabled="isLoading"
        density="compact"
        data-cy="edit"
        class="me-2"
        hide-details
        max-width="140"
    />
    <span v-else class="me-2" v-text="formData ? formData : `${$t(`${subtitle}`)}`" />
    <template v-if="authStore.isTO1">
        <v-btn
            v-if="!isEditing"
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            icon="mdi-pencil"
            variant="text"
            size="x-small"
            data-cy="edit"
            @click="isEditing = true"
        />
        <v-btn
            v-if="isEditing"
            :loading="isLoading"
            :disabled="isLoading"
            color="error"
            icon="mdi-close"
            variant="text"
            size="x-small"
            data-cy="cancel"
            @click="cancelEditing"
        >
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn
            v-if="isEditing"
            :loading="isLoading"
            :disabled="isLoading"
            color="success"
            icon="mdi-check"
            variant="text"
            size="x-small"
            data-cy="save"
            @click="saveDetails"
        />
    </template>
</template>

<script setup lang="ts">
    const props = defineProps<{
        title: string
        subtitle: string
    }>()

    const isEditing = ref<boolean>(false)
    const isLoading = ref<boolean>(false)
    const rowData = ref(null)
    const formData = defineModel<string>()

    const emit = defineEmits<{
        (e: 'saveDetails'): void
    }>()

    onMounted(async () => {
        if (formData.value) rowData.value = clone(formData.value)
    })

    const cancelEditing = () => {
        isEditing.value = false
    }

    const saveDetails = () => {
        formData.value = rowData.value
        emit('saveDetails')
        isEditing.value = false
    }
</script>
